import React, { Component } from "react";

export default class IE extends Component {
  render() {
    return (
      <div id="ie-wrapper">
        Working on making it compatible with IE. For now, please visit the
        website using Chrome, Safari or FireFox, many thanks!
      </div>
    );
  }
}
